"use client";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { DEFAULT_USER_INFO_STATE } from "./useUserInfoStore.js";
import { extractAuthInfo } from "@getpara/user-management-client";
const getActions = (set, get) => ({
  resetState: () => {
    set(DEFAULT_USER_INFO_STATE);
  },
  setAuthInfo: (_a) => {
    var _b = _a, { pfpUrl, displayName } = _b, auth = __objRest(_b, ["pfpUrl", "displayName"]);
    set({ auth, pfpUrl: pfpUrl || null, displayName: displayName || null });
  },
  getAuthInfo: () => {
    try {
      return get().auth ? __spreadProps(__spreadValues({}, extractAuthInfo(get().auth, { isRequired: true })), { pfpUrl: get().pfpUrl, displayName: get().displayName }) : null;
    } catch (e) {
      return null;
    }
  },
  setRecoveryShare: (recoveryShare) => {
    set({ recoveryShare });
  }
});
export {
  getActions
};
